import { gql } from '@apollo/client';

export const QUERY_GEOMETRY = gql`
  query AdvancedfilteredMunicipalities(
    $filters: AdvancedFilterInput
    $pagination: PaginationArgs
    $language: String
  ) {
    advancedfilteredMunicipalities(
      filters: $filters
      pagination: $pagination
      language: $language
    ) {
      total
      data {
        municipality_code
        code_uf
        name_municipality
        name_uf
        biome
        population
        classification_type
        name_region
        dimensions_scores {
          score_risk
          score_opportunity
          dimension {
            id
            name
          }
          intensity_color_opportunity
          intensity_color_risk
          classification_risk
          classification_opportunity
        }
        municipality_score {
          general_score_risk
          general_score_opportunity
          classification_risk
          classification_opportunity
          intensity_color_opportunity
          intensity_color_risk
        }
      }
    }
  }
`;

export const QUERY_GEOMETRY_FOR_TABLE = gql`
  query AdvancedfilteredMunicipalities(
    $filters: AdvancedFilterInput
    $pagination: PaginationArgs
    $language: String
  ) {
    advancedfilteredMunicipalities(
      filters: $filters
      pagination: $pagination
      language: $language
    ) {
      total
      data {
        municipality_code
        code_uf
        name_municipality
        name_uf
        classification_type
        municipality_score {
          general_score_risk
          general_score_opportunity
          classification_risk
          classification_opportunity
          intensity_color_opportunity
          intensity_color_risk
        }
        dimensions_scores {
          score_opportunity
          score_risk
          dimension {
            id
            name
            description
            order
            bigquery_id
          }
        }
      }
    }
  }
`;
